import { initSentry } from '@barbanet/app-config'

import type { App } from 'vue'
import VueCookies from 'vue-cookies'

import router from '../router'
import { i18n } from './i18n'
import pinia from './pinia'
import uiKit from './ui-kit'

export async function registerPlugins(app: App) {
	initSentry(app, router)
	app.use(router).use(pinia).use(i18n).use(uiKit).use(VueCookies)
}
